import { Routes } from '@angular/router';
import { MapComponent } from './components/map/map.component';

export const routes: Routes = [
    {
        path: '',
        component: MapComponent,
    },
    {
        path: 'result/:country/:component/:regulation',
        loadChildren: () => import('../result/result.module').then((m) => m.ResultModule),
    },
];
